import React from 'react';
import { Route } from 'react-router-dom';
import { AssessorApplicationForm, CallsignApplicationForm, CertificateApplicationForm } from '../forms';
import { Layout } from '../pages';
import { getApiClient } from '../api';
import { ClientApiProps } from '../common';

export const renderAppRoutes = (props: ClientApiProps) => {
  return (
    <>
      <Route path="/forms/amateurradio/assessor" element={<AssessorApplicationForm {...props} />} />
      <Route path="/forms/amateurradio/assessor/:id" element={<AssessorApplicationForm {...props} />} />

      <Route path="/forms/amateurradio/callsign" element={<CallsignApplicationForm {...props} />} />
      <Route path="/forms/amateurradio/callsign/:id" element={<CallsignApplicationForm {...props} />} />

      {/* Applying for a downloadable certificate for an attained qualification */}
      <Route path="/forms/amateurradio/certificate/:id" element={<CertificateApplicationForm {...props} />} />

      {/* Fallback/Home */}
      <Route path="/amateurradio/*" element={<Layout {...props} />} />
    </>
  );
};

export const getAppNavigation = async (props: ClientApiProps) => {
  const [client] = getApiClient(props.baseUrl, props.b2cDomainName, props.msalClient);
  const check = await client.operatorCheck();
  return check ? [{ order: 50, url: '/amateurradio', title: 'Amateur radio', description: 'Access amateur radio online services' }] : [];
};
